var React = require('react');

function CheckInFilledCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 20a10 10 0 1 1 0-20 10 10 0 1 1 0 20zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829L4.76 9.757 9.003 14z","fill":"#40C057"}));
}

CheckInFilledCircle.defaultProps = {"width":"16","height":"16","viewBox":"0 0 20 20","fill":"none"};

module.exports = CheckInFilledCircle;

CheckInFilledCircle.default = CheckInFilledCircle;
